import { Card, styled } from "@mui/material";

export const StyledCard = styled(Card)(({ theme: { palette, spacing } }) => ({
  height: "100%",
  padding: spacing(3),
  background: palette.main[50],
  border: `4px solid ${palette.common.white}`,
  boxShadow: `0 0 0 2px ${palette.primary.main}`,
}));
